import { styled } from '@mui/system';
import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';
import type { SnackbarProviderProps } from 'notistack';
import type { PropsWithChildren } from 'react';

import { SOY, WHITE } from 'reservations/brand/helpers/v1/palette';

const DEFAULT_SNACKBAR_PROVIDER_PROPS: Partial<SnackbarProviderProps> = {
  maxSnack: 1,
  anchorOrigin: {
    horizontal: 'center',
    vertical: 'top'
  },
  preventDuplicate: true,
  hideIconVariant: true,
  dense: true
};

const StyledSnackbarProvider = styled(NotistackSnackbarProvider)(() => ({
  '&.notistack-MuiContent-error': {
    backgroundColor: WHITE,
    color: 'black',
    fontFamily: 'Inter'
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: WHITE,
    color: SOY,
    fontFamily: 'Inter'
  }
}));

export const SnackbarProvider = ({ children }: PropsWithChildren) => (
  <StyledSnackbarProvider {...DEFAULT_SNACKBAR_PROVIDER_PROPS}>
    {children}
  </StyledSnackbarProvider>
);
